module.exports = __webpack_public_path__ + "static/05-d8c45e239cf6087166e2ec58b7a13527.png";